<template>
  <div class="card" v-show="isSection('freespace')">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>フリースペースを入力</h2>
        <p>
          自由に記入できるスペースです（任意）。最大3行（1行35文字）まで表示されます。
        </p>
      </div>
      <div class="card-content">
        <el-input
          v-model="freespace"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 8 }"
          maxlength="175"
          placeholder="自由にご記入ください"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'

const props = defineProps<{
  currentCardId?: string
  formatId?: string
}>()

const formatData = useRirekishoFormatData()

const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

const freespace = computed({
  get: () => String(formatData.freespace ?? ''),
  set: (value: string) => {
    formatData.freespace = value
  }
})
</script>
